import { useSelector, useDispatch } from 'react-redux'
import Modal from '../Modal'
import TicketsScannerOwnersList from './OwnersList'
import { selectOwners, selectOwnersError, selectShowExtendedModal, dismissExtendedModal, resetAll } from '../../stores/ticketsScanner/actions'

const TicketsScannerExtendedListModal = () => {
  const owners = useSelector(selectOwners)
  const searchError = useSelector(selectOwnersError)
  const showExtendedModal = useSelector(selectShowExtendedModal)
  const dispatch = useDispatch()

  const handleCancel = () => {
    dispatch(dismissExtendedModal())
    dispatch(resetAll())
  }

  let content

  if (searchError) {
    // `owners.loaded` is only ever set by a successful search, so without this a failed
    // "show all results" would spin here for as long as the modal stayed open.
    content = (
      <div className="alert alert-danger text-center">
        <h3>{I18n.t("tickets_scanner.errors.search_failed")}</h3>
      </div>
    )
  } else if (owners.loaded) {
    if (owners.list.length > 0) {
      content = <TicketsScannerOwnersList owners={owners.list} />
    } else {
      content = (
        <div className="alert alert-warning text-center">
          <h3>{I18n.t("tickets_scanner.owners_list.not_found")}</h3>
        </div>
      )
    }
  } else {
    content = (
      <div className="text-center">
        <i className="fa fa-spinner fa-4x fa-spin"></i>
      </div>
    )
  }

  const bodyStyle = {
    padding: "15px",
  }

  const footerStyle = {
    padding: "15px",
    textAlign: "right",
    borderTop: "1px solid #e5e5e5",
  }

  return (
    <Modal
      show={showExtendedModal}
      title={I18n.t("tickets_scanner.owners_list.modal_title")}
      onHide={handleCancel}
    >
      <div style={bodyStyle}>{content}</div>
      <div style={footerStyle}>
        <button
          type="button"
          className="btn btn-block btn-primary"
          onClick={handleCancel}
        >
          {I18n.t("tickets_scanner.owners_list.cancel")}
        </button>
      </div>
    </Modal>
  )
}

export default TicketsScannerExtendedListModal
